import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'manage',
    title: 'Manage Crexendo Marketplace',
    loadChildren: () => import('./management/management.module').then(m => m.ManagementModule)
  },
  {
    path: 'dashboard',
    title: 'Crexendo Marketplace',
    loadChildren: () => import('./account/account.module').then(m => m.AccountModule)
  },
  {
    path: ':partner_name',
    title: 'Crexendo Marketplace',
    loadChildren: () => import('./features/store/store.module').then(m => m.StoreModule)
  },
  { path: '**', redirectTo: 'dashboard/main' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
